export default __webpack_public_path__ + "static/media/xls.20f56f78.svg";